import { BEHAVIOR_OPTIONS } from './constants';
import type { BehaviorOption } from './types';

/**
 * Determines whether the Room for Rent checkbox should be displayed
 * based on property type and behavior mode.
 *
 * The checkbox is only shown when:
 * - Property is not a multiplex
 * - Property is not a community type
 * - Behavior is in ADD mode (not EDIT)
 */
export const shouldDisplayRoomForRentCheckbox = (
  isMultiplexType: boolean,
  isCommunityType: boolean,
  behavior: BehaviorOption,
): boolean => {
  return !isMultiplexType && !isCommunityType && behavior === BEHAVIOR_OPTIONS.ADD;
};
